module.exports = __webpack_public_path__ + "static/img/bannernew.bec0ba1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/bannernew.jpg
// module id = dwP+
// module chunks = 1